import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'chatTypePipe'})
export class ChatTypePipe implements PipeTransform  {

  constructor() {}
  transform(chatTypeKey) {
    let chatTypeValue: string;

    switch (chatTypeKey) {
      case 'ADMIN_QUESTION':
        chatTypeValue = 'Вопрос администратору';
        break;
      case 'CURATOR_QUESTION':
        chatTypeValue = 'Вопрос куратору';
        break;
      case 'COMMON_QUESTION':
        chatTypeValue = 'Общий вопрос';
        break;
      case 'CONTACT_CHANGE':
        chatTypeValue = 'Изменение контактной информации';
        break;
      default:
        console.log("Chat type is not found");
    }

    return chatTypeValue;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/chatType.pipe.ts